import { ActionButton } from '../ActionButton/ActionButton';

/**
 * {@docCategory Button}
 */
export const CommandButton = ActionButton;
